import React, { useState } from "react";
import icon from "../../../Assets/gallary1.svg";
import tiketicon from "../../../Assets/ticket icon.svg";
import invoice from "../../../Assets/invoice (1).svg";

const ProductDetailsRepair = ({
  records,
  onViewInvoice,

  updateStatus,
}) => (
  <div className="p-6  min-h-screen">
    <div className="max-w-7xl mx-auto">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6">
        {records
          .slice() // Create a shallow copy to avoid mutating the original array
          .reverse() // Reverse the order of records
          .map((record) => (
            <ProductCard
              key={record._id}
              record={record}
              onViewInvoice={onViewInvoice}
         
              updateStatus={updateStatus} // Pass the status update function
            />
          ))}
      </div>
    </div>
  </div>
);

const ProductCard = ({ record, onViewInvoice, updateStatus }) => {
  const [newStatus, setNewStatus] = useState("");
  const [customText, setCustomText] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false); // State for modal visibility
  const [currentRecord, setCurrentRecord] = useState(record); // Local state for the current record

  const handleStatusUpdate = async () => {
    const statusToUpdate = newStatus === "Other" ? customText : newStatus;
    if (newStatus || customText) {
      try {
        // Assume updateStatus is a function that updates the status in the backend
        await updateStatus(record._id, statusToUpdate);

        // Update local state with the new status
        setCurrentRecord((prevRecord) => ({
          ...prevRecord,
          statusUpdates: [
            ...prevRecord.statusUpdates,
            {
              status: statusToUpdate,
              date: new Date().toISOString(),
            },
          ],
        }));
        setNewStatus("");
        setCustomText("");
      } catch (error) {
        console.error("Failed to update status:", error);
      }
    }
  };
  const getImageUrl = (filePath) => {
    const baseUrl = "https://backend.securenetindia.com"; // backend URL (update to actual domain in production)
    const formattedPath = filePath.replace(/\\/g, "/"); // Windows \ to web /
    return `${baseUrl}/${formattedPath}`;
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
  };
  
  
  const latestStatus =
    currentRecord.statusUpdates?.[currentRecord.statusUpdates.length - 1]
      ?.status || "N/A";

  return (
    <div className="bg-white border-dashed border shadow-[0px_10px_60px_0px_#E2ECF980] border-gray-300 rounded-lg p-6  transition-shadow duration-300">
      <div className="mb-4 flex justify-between items-center border-gray-300 ">
        <div className="flex items-center">
          <img src={tiketicon} alt="Ticket Icon" className="w-8 h-8 mr-4" />{" "}
          {/* Icon added on the left */}
          <h3 className="text-xl font-semibold text-gray-800">
            Ticket #{currentRecord.ticketNumber}
          </h3>
        </div>
        {currentRecord.file && (
          <button
          onClick={() => {
            const imageUrl = getImageUrl(currentRecord.file);
            window.open(imageUrl, "_blank"); // Opens the image in a new tab
          }}
            className="flex-1 text-white text-sm px-4 py-2 rounded-lg flex items-end justify-end"
          >
            <img src={icon} alt="Product Image" className="w-8 h-8" />
          </button>
        )}
      </div>
      <div className="-mx-6">
        <hr className="border-gray-300 mb-4" />
      </div>

      <div className="text-gray-700 space-y-2">
        <div className="flex justify-between">
          <p className="text-[#B5B7C0] font-[20px]">Product Name</p>
          <p className="text-[#292D32] font-semibold">
            {currentRecord.productDetails?.productName || "N/A"}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-[#B5B7C0] font-[20px]">Purchase From</p>
          <p className="text-[#292D32] font-semibold">
            {currentRecord.purchaseFrom || "N/A"}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-[#B5B7C0]">Serial No.</p>
          <p className="text-[#292D32] font-semibold">
            {currentRecord.productDetails?.serialNo || "N/A"}
          </p>
        </div>
        <div className="flex justify-between">
          <p className="text-[#B5B7C0]">Model No.</p>
          <p className="text-[#292D32] font-semibold">
            {currentRecord.productDetails?.modelNo || "N/A"}
          </p>
        </div>
    <div className="flex justify-between">
  <p className="text-[#B5B7C0]">Purchase Date</p>
  <p className="text-[#292D32] font-semibold">
    {currentRecord.productDetails?.purchaseDate
      ? formatDate(currentRecord.productDetails.purchaseDate)
      : "N/A"}
  </p>
</div>
<div className="flex justify-between">
  <p className="text-[#B5B7C0]">Expiry Date</p>
  <p className="text-[#292D32] font-semibold">
    {currentRecord.productDetails?.expiryDate
      ? formatDate(currentRecord.productDetails.expiryDate)
      : "N/A"}
  </p>
</div>

        <div className="flex justify-between">
          <p className="text-[#B5B7C0]">Query</p>
          <p className="text-[#292D32] font-semibold">{currentRecord.query}</p>
        </div>
        <div className="flex justify-between">
          <p className="text-[#B5B7C0]">Address</p>
          <p className="text-[#292D32] font-semibold">
            {currentRecord.address}
          </p>
        </div>
        <div className="flex justify-between items-center p-2">
          <p className="text-[#B5B7C0]">Latest Status</p>
          <p
          className={`font-semibold px-2 py-1 rounded-full ${
            latestStatus === "Under Process"
              ? "text-blue-500 bg-blue-100"
              : latestStatus === "On Hold"
              ? "text-yellow-500 bg-yellow-100"
              : latestStatus === "Completed"
              ? "text-green-500 bg-green-100"
              : latestStatus === "Delivered"
              ? "text-purple-500 bg-purple-100"
              : latestStatus === "Other"
              ? "text-orange-500 bg-orange-100"
              : "text-gray-500 bg-gray-100"
          }`}
        >
          {latestStatus || "No Status"}
        </p>

        </div>

        <div className="flex justify-between items-center space-x-2">
          <p className="text-[#B5B7C0]">Status</p>
          <button
            onClick={() =>
              onViewInvoice(record.productDetails?.invoice || "N/A")
            }
            className="bg-[#1C50A3] text-white font-semibold text-xs px-3 py-2 rounded-2xl  flex items-center space-x-2"
          >
            <img
              src={invoice}
              alt="icon"
              className="w-4 h-4" // Adjust size as needed
            />
            <span>View Invoice</span>
          </button>
        </div>
      </div>
      <div className="-mx-6 mt-3">
        <hr className="border-gray-300 mb-4" />
      </div>

      <div className="mt-2 flex flex-col space-y-4">
        {/* Select dropdown */}
        <div>
          <label
            htmlFor="status"
            className="block mb-2 text-sm font-medium text-[#292D32]"
          >
            Update Status:
          </label>
          <select
            id="status"
            value={newStatus}
            onChange={(e) => {
              setNewStatus(e.target.value);
              if (e.target.value !== "Other") {
                setCustomText("");
              }
            }}
            className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-1 focus:ring-gray-400 focus:border-gray-400 sm:text-sm"
          >
            <option value="">Select Status</option>
            <option value="Under Process">Under Process</option>
            <option value="On Hold">On Hold</option>
            <option value="Completed">Completed</option>
            <option value="Delivered">Delivered</option>
            <option value="Other">Other</option>
          </select>
          {newStatus === "Other" && (
            <textarea
              id="custom-text"
              value={customText}
              onChange={(e) => setCustomText(e.target.value)}
              className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
              placeholder="Enter custom status"
            />
          )}
        </div>

        {/* Buttons container */}
        <div className="flex justify-center items-center space-x-4">
          <button
            onClick={() => setIsModalOpen(true)} // Open modal
            className="bg-[#E0E0E0] text-black px-2 py-2 text-sm font-medium rounded w-40 h-10 
               hover:bg-[#D6D6D6] hover:shadow-md transition duration-200"
          >
            Status History
          </button>
          <button
            onClick={handleStatusUpdate}
            className="bg-gradient-to-r from-[#1C50A3] to-[#2B68C8] text-white px-2 py-2 font-medium rounded w-40 h-10 
               hover:from-[#1A4788] hover:to-[#255FA5] hover:shadow-lg transition duration-200"
          >
            Confirm Status
          </button>
        </div>

        {/* Modal for Status History */}
        {isModalOpen && (
          <div className="fixed inset-0 bg-gray-800 bg-opacity-40 flex justify-center items-center z-50">
            <div className="bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative max-h-[80vh] overflow-y-auto">
              <button
                onClick={() => setIsModalOpen(false)}
                className="absolute top-4 right-4 text-white bg-[#1C50A3]  rounded-full text-xl leading-none focus:outline-none h-8 w-8"
              >
                &times;
              </button>
              <h4 className="text-lg font-semibold text-gray-800 mb-4">
                Status History
              </h4>
              <div className="-mx-6">
                <hr className="border-gray-300 " />
              </div>
              <div className="border-gray-200">
                {currentRecord.statusUpdates?.length > 0 ? (
                  <div className="text-left">
                    <ul className="list-none p-0">
                      {currentRecord.statusUpdates.map((update, index) => {
                        const date = new Date(update.date);

                        // Format Date (e.g., 15 Nov 2024)
                        const formattedDate = date.toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "short",
                          year: "numeric",
                        });

                        // Format Time (e.g., 2:20 PM)
                        const formattedTime = date.toLocaleTimeString("en-GB", {
                          hour: "2-digit",
                          minute: "2-digit",
                          hour12: true,
                        });

                        return (
                          <li
                            key={index}
                            className="flex items-center pt-8 justify-between relative"
                          >
                            {/* Circle for active status */}
                            <div
                              className={`w-3 h-3 ml-1 rounded-full bg-[#1C50A3] absolute left-0 transform -translate-x-1/2 
                        ${
                          index === currentRecord.statusUpdates.length - 1
                            ? "w-5 h-5"
                            : ""
                        }`}
                            >
                              {index ===
                                currentRecord.statusUpdates.length - 1 && (
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  className="w-3 h-3 text-white absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke="currentColor"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth="2"
                                    d="M5 13l4 4L19 7"
                                  />
                                </svg>
                              )}
                            </div>
                            {/* Vertical line between circles */}
                            {index > 0 && (
                              <div className="absolute left-1 w-px h-full bg-[#1C50A3] transform -translate-y-2/4" />
                            )}
                            <span className="flex-1 text-left text-gray-500 pl-8">
                              <strong>{update.status}</strong>
                            </span>
                            <span className="text-right text-[#292D32]">
                              {formattedTime}
                            </span>{" "}
                            <span> , </span>
                            <span className="text-right  text-[#292D32]">
                              {formattedDate}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                ) : (
                  <p className="text-gray-600">No status updates available</p>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ProductDetailsRepair;
